import React, {Component} from 'react';
import {reqGetManufacturingInfo} from '../../../api';
import {formatDate} from '../../../utils/utility';

export default class ManufacturingInfo extends Component {

  constructor(props) {
    super(props);
    this.state = {
      stones: [],
    }
  }

  componentDidMount() {
    reqGetManufacturingInfo(this.props.style.order_id)
      .then(response => {
        this.setState({stones: response.data})
      })
      .catch(error => {
        console.log(error)
      });
  }

  generateStones = (stones) => {
    if (stones.length === 1) {
      return <p style={{marginBottom: 0}}>Center: {stones[0].shape} {stones[0].type}&nbsp;
        {(stones[0].type == 'LAB-GROWN' || stones[0].type == 'NATURAL') && 'Diamond '}
        {!!stones[0].carats && (stones[0].carats + 'ct')}&nbsp;
        {stones[0].measurements}</p>
    } else if (stones.length > 0) {
      return stones.map((item,index) => (
        <p key={item.id}
           style={{color: 'red', marginBottom: 0}}>Center: {item.shape} {item.type}&nbsp;
          {(item.type == 'LAB-GROWN' || item.type == 'NATURAL') && 'Diamond '}
          {!!item.carats && (stones[index].carats + 'ct')}&nbsp;
          {item.measurements}</p>
      ))
    }
  }

  componentDidUpdate(prevProps) {
    // Typical usage (don't forget to compare props):
    if (this.props.style !== prevProps.style) {
      reqGetManufacturingInfo(this.props.style.order_id)
        .then(response => {
          this.setState({stones: response.data})
        })
        .catch(error => {
          console.log(error)
        });
    }
  }

  render() {
    const style = this.props.style;
    return (
      <div>
        {!!style.po_number ? <p style={{marginBottom: 0}}>PO#: {style.po_number}</p> :
          <p style={{color: 'red', marginBottom: 0}}>PO#: {style.po_number}</p>}

        {(!!style.head_metal && style.head_metal !== style.mount_metal) ?
          <>
            <p style={{marginBottom: 0}}>Head Metal:{style.head_metal}</p>
            <p style={{marginBottom: 0}}>Mount Metal:{style.mount_metal}</p>
          </>
          :
          <p style={{marginBottom: 0}}>Metal: {style.mount_metal}</p>}

        {this.generateStones(this.state.stones)}

        {!!style.finger_size ? <p style={{marginBottom: 0}}>Size: {style.finger_size}</p> :
          <p style={{color: 'red', marginBottom: 0}}>Size: {style.finger_size}</p>}
        <br/>

        {!!style.ring_type && <p style={{marginBottom: 0}}>- {style.ring_type}</p>}
        {!!style.center_prongs && <p style={{marginBottom: 0}}>- Set center with {style.number_of_prongs} {style.center_prongs}</p>}
        {!!style.head_details && <p style={{marginBottom: 0}}>- {style.head_details}</p>}
        {!!style.shoulders && <p style={{marginBottom: 0}}>- {style.shoulders}</p>}
        {!!style.side_stones && <p style={{marginBottom: 0}}>- {style.side_stones}</p>}
        {!!style.width_details && <p style={{marginBottom: 0}}>- {style.width_details}</p>}
        {!!style.thickness_details && <p style={{marginBottom: 0}}>- Thickness: {style.thickness_details}</p>}
        {!!style.band_details && <p style={{marginBottom: 0}}>- {style.band_details}</p>}
        {!!style.wb_consideration && <p style={{marginBottom: 0}}>- {style.wb_consideration}</p>}
        <br/>
        {!!style.description && <>
          <p style={{marginBottom: 0}}>Extra Details:</p>
          <p style={{whiteSpace: 'pre-line', paddingLeft: '1em', marginBottom: 0}}>{style.description}</p>
          <br/>
        </>}
        {!!style.internal_details && <>
          <p style={{marginBottom: 0}}>Internal Note:</p>
          <p style={{whiteSpace: 'pre-line', paddingLeft: '1em', marginBottom: 0}}>{style.internal_details}</p>
          <br/>
        </>}
        {!!style.client_review_date && <p style={{marginBottom: 0}}>- Client Review Date: {formatDate(style.client_review_date)}</p>}
        <p><strong>**refer to picture for top down AND profile view</strong></p>
      </div>
    )
  }


}